export const toMs = (value: string): number => {
	const trimmed = value.trim();
	const amount = Number.parseFloat(trimmed);

	if (!Number.isFinite(amount)) return 0;

	return trimmed.endsWith("ms") ? amount : amount * 1000;
};

export const settle = (element: HTMLElement, ms: number, done: () => void): (() => void) => {
	const listeners = new AbortController();

	let timer: number | undefined;

	const finish = () => {
		listeners.abort();
		window.clearTimeout(timer);
		timer = undefined;
		done();
	};

	/* The element's own transition, never a descendant's: a staggered child ends first and would
	   cut the exit short. The timer is the only cover where the element itself never transitions. */
	element.addEventListener(
		"transitionend",
		(event) => {
			if (event.target === element) finish();
		},
		{ signal: listeners.signal },
	);

	timer = window.setTimeout(finish, ms);

	return () => {
		listeners.abort();
		window.clearTimeout(timer);
		timer = undefined;
	};
};

export const settled = (element: HTMLElement, ms: number): Promise<void> =>
	new Promise((resolve) => {
		settle(element, ms, resolve);
	});
